"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InstantResultContent = void 0;
var _logger = require("../../logger");
var _Skeleton = require("../Skeleton");
var _InstantResultListRow = require("./InstantResultListRow");
var _NoResultsMessage = require("./NoResultsMessage");
var _jsxRuntime = require("react/jsx-runtime");
// TODO: Reduce props
const componentName = 'InstantResultContent.tsx';
const InstantResultContent = (param)=>{
    let { instantResults, isInstantResultsLoading, searchTerm, selectInstantResult } = param;
    (0, _logger.logDebug)("Rendering ".concat(componentName, " ..."), {
        isInstantResultsLoading,
        instantResults
    });
    if (isInstantResultsLoading) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Skeleton.InstantResultSkeleton, {});
    }
    if (instantResults.length === 0) {
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_NoResultsMessage.NoResultsMessage, {
            searchTerm: searchTerm
        });
    }
    return instantResults.map((point)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(_InstantResultListRow.InstantResultListRow, {
            instantResultPickupPoint: point,
            searchTerm: searchTerm,
            selectInstantResult: selectInstantResult
        }, point.deliveryChannelId));
};
exports.InstantResultContent = InstantResultContent;
